module.exports = __webpack_public_path__ + "img/bus-service-icon2.ffd609d8.png";